import ListItem from './ListItem.vue';
import TableClient from './TableClient.vue';

export default {
    ListItem,
    TableClient
}